import React, { useEffect, useState } from 'react';
import { SideNavPanel } from './side-nav-panel/side-nav-panel';
import { SideNavDialog } from './side-nav-dialog/side-nav-dialog';
import { ISideNavRoute } from './side-nav.models';
import { PagePath } from '../navigation.enums';
import { FocusPanel } from '@keplerco/core';
import { themedAssetUrl } from '../../theme-asset-url';

export function SideNav(props: { isMobile: boolean; isTablet: boolean; showSideNavDialog: boolean; onCloseSideNavDialog: () => void }): JSX.Element {
  const { isMobile, isTablet, showSideNavDialog, onCloseSideNavDialog } = props;
  const [learnerRoutes] = useState<ISideNavRoute[]>(
    [
      {
        icon: themedAssetUrl('icons/sidebar/report-management.icon.svg'),
        path: PagePath.roles,
        title: 'Search Roles',
      },
    
      {
        icon: themedAssetUrl('icons/sidebar/skills-gaps.icon.svg'),
        path: PagePath.skills,
        title: 'Your Skills',
      },
    ]
  );
  function onOpenSettings() {
  }

  function onCloseSettings() {
  }

  return (
    <React.Fragment>
      {!isMobile && !isTablet ? (
        <SideNavPanel learnerRoutes={learnerRoutes} onOpenSettings={onOpenSettings} />
      ) : (
        <SideNavDialog learnerRoutes={learnerRoutes} companyRoutes={learnerRoutes} open={showSideNavDialog} onClose={onCloseSideNavDialog} onOpenSettings={onOpenSettings} />
      )}
    </React.Fragment>
  );
}

